<script>
import IncorporacionAbandonoItem from "./IncorporacionAbandonoItem.vue";
export default {
  props: {
    titulo: {
      type: String,
      required: true,
    },
    dias: {
      type: Array,
      required: true,
    },
    selected: {
      type: Object | null,
      required: true,
    },
    min: {
      type: String | false,
      default: false,
    },
    max: {
      type: String | false,
      default: false,
    },
  },
  components: {
    Item: IncorporacionAbandonoItem,
  },
  methods: {
    update(item) {
      this.$emit("update", item);
    },
    isDisabled(dia) {
      const fecha = new Date(dia.fecha);
      if (this.min) {
        if (fecha <= new Date(this.min)) return true;
      }
      if (this.max) {
        if (fecha >= new Date(this.max)) return true;
      }
      return false;
    },
  },
};
</script>

<template>
  <div v-if="dias.length > 0">
    <h4 v-html="titulo"></h4>
    <table class="table table-condensed" aria-hidden="true">
      <tbody>
        <Item
          v-for="dia in dias"
          :key="dia.fecha"
          :item="dia"
          :selected="selected"
          :disabled="isDisabled(dia)"
          @update="update"
        />
      </tbody>
    </table>
  </div>
</template>

<style lang="scss"></style>
